import Link from "@insite/mobius/Link";
import ListItem, { OrderedList, UnorderedList } from "@insite/mobius/Lists";
import Typography from "@insite/mobius/Typography";
import { StyleguideSection } from "@toolkit/Library/Components/Styleguide/ui";
import React, { FC } from "react";

const StyleguideTypographies: FC = () => {
    return (
        <StyleguideSection title="Typography">
            <Typography variant="h1">This is a h1 heading</Typography>
            <Typography variant="p">
                <Link href="#">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</Link> Nunc quis urna sed sem
                pellentesque fermentum. Ut auctor libero sed eros finibus faucibus vel nec augue. Etiam ultricies id
                augue et imperdiet. Sed congue leo a condimentum rutrum. Sed suscipit consequat finibus. Aliquam
                sagittis tempor eleifend. Maecenas vulputate dui ac justo volutpat ornare. Phasellus augue felis,
                tristique eget urna id, pharetra tempor arcu. Pellentesque eget purus vel ex pellentesque ultricies.
                Phasellus at venenatis ligula. Suspendisse vel odio urna. Nulla sed odio lacus. Nunc dapibus lobortis
                elementum. Curabitur a sapien rutrum dolor pulvinar tempor. Suspendisse ullamcorper, dui vel cursus
                feugiat, sem metus sollicitudin lectus, eget scelerisque lectus risus nec tortor.
            </Typography>
            <Typography variant="h2">This is a h2 heading</Typography>
            <Typography variant="p">
                <strong>Etiam ultricies id augue et imperdiet:</strong>
            </Typography>
            <UnorderedList>
                <ListItem>
                    Nunc quis urna sed sem pellentesque fermentum. Ut auctor libero sed eros finibus faucibus vel nec
                    augue. Etiam ultricies id augue et imperdiet.
                </ListItem>
                <ListItem>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc quis urna sed sem pellentesque
                    fermentum. Ut auctor libero sed eros finibus faucibus vel nec augue. Etiam ultricies id augue et
                    imperdiet. Sed congue leo a condimentum rutrum. Sed suscipit consequat finibus.
                </ListItem>
                <ListItem>Lorem ipsum dolor sit amet</ListItem>
            </UnorderedList>
            <Typography variant="p">
                <em>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc quis urna sed sem pellentesque
                    fermentum. Ut auctor libero sed eros finibus faucibus vel nec augue. Etiam ultricies id augue et
                    imperdiet.
                </em>
            </Typography>
            <Typography variant="h3">This is a h3 heading</Typography>
            <Typography variant="p">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc quis urna sed sem pellentesque fermentum.
                Ut auctor libero sed eros finibus faucibus vel nec augue. Etiam ultricies id augue et imperdiet. Sed
                congue leo a condimentum rutrum. Sed suscipit consequat finibus.
            </Typography>
            <Typography variant="p">
                Aliquam sagittis tempor eleifend. Maecenas vulputate dui ac justo volutpat ornare. Phasellus augue
                felis, tristique eget urna id, pharetra tempor arcu. Pellentesque eget purus vel ex pellentesque
                ultricies. Phasellus at venenatis ligula. Suspendisse vel odio urna.
            </Typography>
            <OrderedList>
                <ListItem>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc quis urna sed sem pellentesque
                    fermentum. Ut auctor libero sed eros finibus faucibus vel nec augue. Etiam ultricies id augue et
                    imperdiet. Sed congue leo a condimentum rutrum. Sed suscipit consequat finibus.
                </ListItem>
                <ListItem>Lorem ipsum dolor sit amet</ListItem>
                <ListItem>
                    Nunc quis urna sed sem pellentesque fermentum. Ut auctor libero sed eros finibus faucibus vel nec
                    augue. Etiam ultricies id augue et imperdiet.
                </ListItem>
            </OrderedList>
            <Typography variant="h4">This is a h4 heading</Typography>
            <Typography variant="p">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc quis urna sed sem pellentesque fermentum.
                Ut auctor libero sed eros finibus faucibus vel nec augue. Etiam ultricies id augue et imperdiet.
            </Typography>
            <Typography variant="p">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc quis urna sed sem pellentesque fermentum.
                Ut auctor libero sed eros finibus faucibus vel nec augue. Etiam ultricies id augue et imperdiet. Sed
                congue leo a condimentum rutrum. Sed suscipit consequat finibus. Aliquam sagittis tempor eleifend.
                Maecenas vulputate dui ac justo volutpat ornare. Phasellus augue felis, tristique eget urna id, pharetra
                tempor arcu. Pellentesque eget purus vel ex pellentesque ultricies. Phasellus at venenatis ligula.
                Suspendisse vel odio urna.
            </Typography>
            <Typography variant="h5">This is a h5 heading</Typography>
            <Typography variant="p">
                Nunc quis urna sed sem pellentesque fermentum. Ut auctor libero sed eros finibus faucibus vel nec augue.
                Etiam ultricies id augue et imperdiet. Sed congue leo a condimentum rutrum. Sed suscipit consequat
                finibus.
            </Typography>
            <Typography variant="p">
                Maecenas vulputate dui ac justo volutpat ornare. Phasellus augue felis, tristique eget urna id, pharetra
                tempor arcu. Pellentesque eget purus vel ex pellentesque ultricies. Phasellus at venenatis ligula.
                Suspendisse vel odio urna. Aliquam sagittis tempor eleifend.
            </Typography>
            <Typography variant="h6">This is a h6 heading</Typography>
            <Typography variant="p">
                Pellentesque eget purus vel ex pellentesque ultricies. Phasellus at venenatis ligula. Suspendisse vel
                odio urna. <Link href="#">Aliquam sagittis tempor eleifend.</Link>
            </Typography>
            <Typography variant="p">
                Phasellus augue felis, tristique eget urna id, pharetra tempor arcu. Pellentesque eget purus vel ex
                pellentesque ultricies. Phasellus at venenatis ligula. Suspendisse vel odio urna.
            </Typography>
            <Typography variant="legend">This is a LEGEND</Typography>
        </StyleguideSection>
    );
};

export default StyleguideTypographies;
